import React, { FC, useState, useEffect } from 'react';
import LocalModal from 'components/base/local-modal';
import { ReactComponent as ListIcon } from 'assets/icons/list-icon.svg';
import { Button } from '@cokitchen/cokitchen-components';
import CsvIcon from 'assets/images/csv.png';
import { useNavigate } from 'react-router-dom';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
// import { DefaultvendorFormData } from '../add-vendor';
import CsvInfoModal from '../csv-info-modal';
import useSettingsContext from 'contexts/settings.context/context';
import { DefaultUserFormData } from 'pages/settings/manage-users/add-user/add-user-details';
import * as XLSX from 'xlsx';
import { UserXlsType } from 'models/user.model';
import { apiService } from 'services/base.service';
import { RoleType } from 'models/role.model';

type AddStoreItemProps = {
  show: boolean;
  onClose: () => void;
};

const StoreItemAdditionDetails = {
  subtitle:
    'Welcome to the store item addition process via CSV file. Please Follow these steps to ensure a smooth member addition:',
  steps: [
    {
      number: 1,
      heading: 'Download the Template',
      description: "Click the 'Download CSV Template' button to obtain the template file."
    },
    {
      number: 2,
      heading: 'Fill in store items Details',
      description: ' Open the downloaded CSV file, Specify the role of each vendor.'
    },
    {
      number: 3,
      heading: 'Save Your Changes',
      description: 'Save the CSV file with your entries'
    },
    {
      number: 4,
      heading: 'Review',
      description:
        'Crosscheck the details in the CSV file. Click confirm to select the file and upload'
    },
    {
      number: 5,
      heading: 'Verify the details',
      description:
        'After uploading, the details will be displayed for final review before addition,then click continue to add members to the company'
    }
  ]
};
const AddUserModal: FC<AddStoreItemProps> = ({ show, onClose }) => {
  const navigate = useNavigate();
  const [showCsvInfoModal, setShowCsvInfoModal] = useState(false);
  const { active, setActive, setStep, setUserFormData } = useSettingsContext();
  const [file, setFile] = useState<File | null>(null);
  const [roles, setRoles] = useState([] as RoleType[]);
  const toggleCsvInfoModal = () => {
    setShowCsvInfoModal(!showCsvInfoModal);
  };

  const readFile = () => {
    if (file) {
      const reader = new FileReader();
      reader.readAsBinaryString(file);
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const data = e.target?.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const vendorDetails = workbook.SheetNames[0];
        const vendorDetailsJson: UserXlsType[] = XLSX.utils.sheet_to_json(
          workbook.Sheets[vendorDetails]
        );
        const formattedUserData = vendorDetailsJson.map((details) => {
          const getRole = roles.find(
            (role) => role.name.toLowerCase().trim() === details['Role'].toLowerCase().trim()
          );
          return {
            phone_number: details['Phone number'],
            first_name: details['First name'],
            last_name: details['Last name'],
            email: details['Email'],
            role: { name: getRole?.name ?? '', id: getRole?.id ?? '' }
          };
        });

        setUserFormData(formattedUserData);
      };
      navigate(MAIN_STORE_ROUTE_KEYS.INVENTORY_STORE_ITEMS_ADD);
      setStep(1);
      setActive('csv');
    }
  };

  useEffect(() => {
    readFile();
    return () => {
      setActive(null);
    };
  }, [file]);

  const handleFileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    setActive('csv');
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files) setFile(files[0]);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };
  const handleFileUpload = (e: any) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };
  const reset = () => {
    setActive('csv');
  };
  const getRoles = async () => {
    try {
      const response = await apiService.get('user/role');
      const data = response.data.data ?? [];
      if (data) {
        setRoles(data);
      }
    } catch (err: any) {
      console.log(err);
    }
  };
  useEffect(() => {
    getRoles();
  }, []);

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={() => {
        onClose();
        setActive(null);
      }}
      title='Add Users'
      contentClassName='!max-w-[442px]'>
      <div className='flex gap-4 my-4 w-full '>
        <div
          onClick={() => {
            setActive('csv');
            toggleCsvInfoModal();
          }}
          onDrop={handleFileDrop}
          onDragOver={handleDragOver}
          className={`${
            active === 'csv' ? 'border-[#E60A2B] border-[1.5px]' : 'border-[#EAEBEB]'
          } border w-full sm:w-[185px] h-[139px]  hover:border-[#E60A2B] cursor-pointer hover:border-[1.5px] p-4 rounded-md space-y-3`}>
          <div className='border border-[#EAEBEB] p-2 rounded-full w-9 h-9 flex items-center'>
            <img src={CsvIcon} alt='' />
          </div>
          <h2 className='text-sm font-semibold'>Add via .csv</h2>
          <p className='text-[#6F7376] text-xs font-normal'>
            Add multiple users to the inventory dashboard
          </p>
        </div>

        <div
          onClick={() => {
            setActive('manual');
            setUserFormData([DefaultUserFormData]);
          }}
          className={`${
            active === 'manual' ? 'border-[#E60A2B] border-[1.5px]' : 'border-[#EAEBEB] '
          } border w-full sm:w-[185px] h-[139px] hover:border-[#E60A2B] cursor-pointer hover:border-[1.5px] p-4 rounded-md space-y-3`}>
          <div className='border border-[#EAEBEB] p-2 rounded-full w-9 h-9 flex items-center'>
            <ListIcon />
          </div>
          <h2 className='text-sm font-semibold'>Add Manually</h2>
          <p className='text-[#6F7376] text-xs font-normal '>
            Add users manually to the inventory dashboard
          </p>
        </div>
      </div>
      <div className='flex justify-end mt-6 '>
        <Button
          color='transparent'
          variant='block'
          small
          className='w-[139px] '
          onClick={() => {
            onClose();
            setActive(null);
          }}>
          Cancel
        </Button>
        <Button
          color='primary'
          variant='block'
          small
          className='w-[139px]'
          onClick={() => navigate(MAIN_STORE_ROUTE_KEYS.MANAGE_USERS_ADD_USERS)}>
          Continue
        </Button>
      </div>
      {showCsvInfoModal && (
        <CsvInfoModal
          show={showCsvInfoModal}
          onClose={toggleCsvInfoModal}
          handleFileUpload={handleFileUpload}
          handleFileChange={reset}
          title='Add users via CSV file'
          downloadLink='https://docs.google.com/spreadsheets/d/1CqqrThB87fgFE4Bunl7xxPEhJzFSdA3wd7Au5oaJw18/export?format=xlsx'>
          <div className='w-full max-w-[400px]'>
            <h2 className='text-sm text-[#2E3031]'>{StoreItemAdditionDetails.subtitle}</h2>
            <div>
              {StoreItemAdditionDetails.steps.map((step) => (
                <div className='flex items-center max-w-[400px]' key={step.number}>
                  <div className='inline-block relative'>
                    <span className='w-5 h-5 bg-[#e7e8e9] text-sm rounded-full flex items-center justify-center mb-2 mr-2 p-1'>
                      {step.number}
                    </span>
                  </div>
                  <span className='mt-3'>
                    <h3 className='text-sm font-medium '>{step.heading}</h3>
                    <p className='text-xs'>{step.description}</p>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </CsvInfoModal>
      )}
    </LocalModal>
  );
};

export default AddUserModal;
